<template>
  <v-row>
    <v-col cols="12">
      <PopupRiskAssessment
        data-cy="risk_assessment_popup"
        @onAssessmentScoreUpdate="onAssessmentScoreUpdate"
        @onSubmit="onAddRiskAssessment"
        v-slot:default="{ on }"
      >
        <v-btn
          v-on="on"
          outlined
          depressed
          color="primary"
          :loading="loading"
        >
          {{ $t('risk_assessment.buttons.complete') }}
        </v-btn>
      </PopupRiskAssessment>
    </v-col>
    <v-col cols="12">
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th>{{ $t('risk_assessment.form.create_date.label') }}</th>
              <th>{{ $t('risk_assessment.form.title') }}</th>
              <th>{{ $t('risk_assessment.form.risk_score.label') }}</th>
              <th>{{ $t('risk_assessment.form.risk_level.label') }}</th>
              <th width="100px">
                &nbsp;
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(risk_assessment, key) in target.risk_assessments"
              :key="key"
            >
              <td>
                <DateFormat
                  :date="risk_assessment.create_date"
                  :showtime="true"
                />
              </td>
              <td>{{ risk_assessment.history.assessment.name }}</td>
              <td>{{ risk_assessment.score?.toFixed(2) }}</td>
              <td>{{ risk_assessment.level }}</td>
              <td>
                <v-dialog
                  max-width="1200"
                >
                  <template v-slot:default="dialog">
                    <v-card>
                      <v-card-text>
                        <RiskAssessmentHistory
                          :risk-assessment="risk_assessment"
                          @close="() => {
                            dialog.value = false
                          }"
                        />
                      </v-card-text>
                    </v-card>
                  </template>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      text
                      color="primary"
                      v-on="on"
                    >
                      {{ $t('risk_assessment.buttons.details') }}
                    </v-btn>
                  </template>
                </v-dialog>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-col>
  </v-row>
</template>

<script>
import DateFormat from '@/components/common/DateFormat'
import RiskAssessmentHistory from '@/components/forms/TransactionDetail3/RiskAssessmentHistory'
import PopupRiskAssessment from '../../popups/PopupRiskAssessment.vue'

export default {
  components: {
    DateFormat,
    RiskAssessmentHistory,
    PopupRiskAssessment
  },
  props: {
    transaction: {
      type: Object,
      required: false,
      default: () => (null)
    },
    person: {
      type: Object,
      required: false,
      default: () => (null)
    },
    company: {
      type: Object,
      required: false,
      default: () => (null)
    }
  },
  data () {
    return {
      assessment: null,
      loading: false
    }
  },
  computed: {
    targetKey () {
      return this.transaction ? 'transaction' : this.person ? 'person' : 'company'
    },
    target () {
      return this.transaction || this.person || this.company
    }
  },
  methods: {
    onAssessmentScoreUpdate (assessment) {
      this.assessment = assessment
    },
    async onAddRiskAssessment () {
      this.loading = true
      const { assessment, score_scaled, level, completed, factor_scores } = this.assessment
      if (completed) {
        if (!this.target.id) {
          this.$notify({
            type: 'error',
            title: this.$t('risk_assessment.msg.save.title'),
            text: `${this.$t('risk_assessment.msg.save.error')} (invalid args)`
          })
          this.loading = false
          return
        }

        this.$store.dispatch('risk/save_risk_assessment', {
          // transaction: this.transaction.id,
          [this.targetKey]: this.target.id,
          history: {
            assessment,
            score: score_scaled,
            level,
            factor_scores
          },
          score: score_scaled,
          level: level.name
        })
          .then(() => {
            this.$notify({
              type: 'success',
              title: this.$t('risk_assessment.msg.save.title'),
              text: this.$t('risk_assessment.msg.save.success')
            })

            this.$emit('reload')
          })
          .catch((error) => {
            console.error(error)
            this.$notify({
              type: 'error',
              title: this.$t('risk_assessment.msg.save.title'),
              text: this.$t('risk_assessment.msg.save.error')
            })
          })
          .finally(() => {
            this.loading = false
          })
      }
    }
  }
}
</script>

<style>
</style>
